export const EMAIL_VALIDATOR =
  /^[\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?\.[\dA-Za-z][\dA-Za-z-]{0,61}[\dA-Za-z]$/
export const URL_VALIDATOR =
  /^https?:\/\/([^#/?]*(\.[^#/?]*)*)([^#?]*)(\?([^#]*))?(#(.*))?/
export const WS_VALIDATOR =
  /^wss?:\/\/([^#/?]*(\.[^#/?]*)*)([^#?]*)(\?([^#]*))?(#(.*))?/
export const LOCALHOST_VALIDATOR = /(localhost){1,6}\b[\w#%&()+./:=?@~-]*$/
// eslint-disable-next-line unicorn/better-regex
export const USERNAME_VALIDATOR = /[^A-Za-z0-9-]/
export const PASSWORD_VALIDATOR = /^\S*$/
export const DERIVATION_PATH_VALIDATOR = /^m\/44'\/60'\/0'\/(\d)\/(\d)$/
export const NUMBER_VALIDATOR = /\p{N}/u
export const SPECIAL_VALIDATOR = /\p{S}|\p{P}|@/u
export const UPPER_CASE_VALIDATOR = /\p{Lu}/u
export const ILLEGAL_VALIDATOR = /\p{C}|\p{Z}/u
export const LOWER_CASE_VALIDATOR = /\p{Ll}/u
